<lx-loading-spinner i18n-message message="Calculating your quote..." [loading]="loading" shadingColor="rgba(0,0,0,0.5)"></lx-loading-spinner>

<div class="qt-form__content" [ngClass]="{ 'qt-form__content--with-aside': stepDefinition?.displayQuote }">
  <div class="qt-form__content-main" id="qt-form-content-main-id">
    <ng-template #router>
      <router-outlet (activate)="scrollToTop()"></router-outlet>
    </ng-template>

    <lx-step-wrapper [stepDefinition]="stepDefinition" [disabledNextButton]="disabledNextButton$ | async">
      <ng-container *ngTemplateOutlet="router"></ng-container>

      <lx-quote-total-price
        #quoteTotalStatic
        class="qt-form__quote-total--static"
        [layout]="QuoteTotalLayouts.EXTENDED"
        [ngClass]="{ 'qt-form__hide': !quoteOutput?.products?.length }"
        [quote]="quoteOutput"
        [selectedCurrency]="exchangeCurrencyCode"
        [hasCurrencySelector]="hasCurrencySelector()"
        [filterVisibleCurrencies]="true"
        (viewDetails)="openSideQuote()"
        (currencyChanged)="updateExchangeCurrency($event)"
      ></lx-quote-total-price>
    </lx-step-wrapper>
  </div>

  <aside class="qt-form__content-side" id="qt-form-content-side-id" *ngIf="stepDefinition?.displayQuote" [@sideQuoteOpen]="isSideQuoteOpen ? 'open' : 'close'">
    <div class="qt-form__content-side__navigation-close">
      <i (click)="closeSideQuote()" class="pi pi-arrow-left qt-form__content-side__navigation-close--icon"></i>
    </div>
    <div class="qt-form__quote-summary" *ngIf="stepDefinition?.displayQuote">
      <h3 i18n>Quote Summary</h3>
      <lx-currency-selector
        *ngIf="hasCurrencySelector()"
        class="qt-form__quote-summary__currency"
        [(currencyCode)]="exchangeCurrencyCode"
        [priceCurrencies]="quoteOutput?.grandTotal"
        [hideDestinationCurrency]="true"
        (currencyCodeChange)="updateExchangeCurrency($event)"
      ></lx-currency-selector>
      <lx-quote
        class="qt-form__quote-summary__quote"
        [ctaButtonHeaderText]="quoteSummaryCtaHeaderText"
        [ctaButtonSubheaderText]="quoteSummaryCtaSubheaderText"
        [languageName]="languageName"
        [schoolName]="schoolName"
        [destination]="destination"
        [quote]="quoteOutput"
        [hasEditButton]="false"
        [hasRemoveButton]="false"
        [hasCurrencySelector]="hasCurrencySelector()"
        [displayDestinationCurrency]="hasCurrencySelector()"
        [selectedCurrency]="exchangeCurrencyCode"
        [displayNoInsurance]="false"
        [displayNoPremiumResidence]="false"
        [displayNoTransfer]="false"
        [hasDisclaimerSection]="true"
        [isProductsAccordionExpanded]="isQuoteProductsAccordionExpanded"
        [isDiscountsAccordionExpanded]="isQuoteDiscountsAccordionExpanded"
        [showCta]="showCtaQuote"
        [disabledCta]="disabledNextButton$ | async"
        [hideDecimals]="true"
        [confirmationDisclaimer]="confirmationDisclaimer"
        [roundedElements]="true"
        (expandProductAccordions)="expandProduct()"
        (expandDiscountAccordions)="expandDiscount()"
        (submitQuote)="submitQuote()"
        (currencyChanged)="updateExchangeCurrency($event)"
      ></lx-quote>
    </div>
  </aside>
</div>

<aside class="qt-form__quote-footer" [@footerQuoteOpen]="isQuoteTotalStaticVisible ? 'close' : 'open'">
  <lx-quote-total-price
    [ngClass]="{ 'qt-form__hide': !quoteOutput?.products?.length }"
    [layout]="QuoteTotalLayouts.COLLAPSED"
    [quote]="quoteOutput"
    [selectedCurrency]="exchangeCurrencyCode"
    [filterVisibleCurrencies]="true"
    (viewDetails)="openSideQuote()"
  ></lx-quote-total-price>
</aside>

<lx-quote-print
  class="qt-form__print-version"
  [quoteOutput]="quoteOutput"
  [studentDetails]="studentDetails"
  [currency]="exchangeCurrencyCode"
  [displayDestinationCurrency]="hasCurrencySelector()"
  [infoDisclaimer]="confirmationDisclaimer"
></lx-quote-print>
